export default __webpack_public_path__ + "static/media/j12.d43dbc6d.jpg";